import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { routes } from './routes'
import { comingSoonRoutes } from './comingSoonRoutes'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes:
    process.env.VUE_APP_COMING_SOON === 'true' ? comingSoonRoutes : routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 50 } }
    }
    return { x: 0, y: 0 }
  },
})

export default router
